import { inject, ref } from 'vue';

export default function useRouteInfo() {
  const axios = inject('axios', undefined);

  let abortController;

  const regionForbidden = ref(null);

  function getRouteInfo(params) {
    abortController?.abort();
    abortController = new AbortController();

    regionForbidden.value = null;

    return axios('/api/route_info', {
      params,
      signal: abortController.signal,
    })
      .catch((err) => {
        if (err.name !== 'CanceledError') {
          const type = err.response?.data?.error?.type;
          if (['from_point_forbidden', 'to_point_forbidden'].includes(type)) {
            regionForbidden.value = type;
          }
          console.error(err);
        }
        throw err;
      });
  }

  return {
    regionForbidden,
    getRouteInfo,
  };
}
